import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetScroll } from "@/lib/scroll";

export const RouteEffects = () => {
  const { pathname, state, hash } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo && !hash) resetScroll();
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};
